export const selectInboxItemCountSelector = (state) => {
    const { pickedTaskCount, notPickedTaskCount } = state.picking;
    return pickedTaskCount !== undefined && notPickedTaskCount !== undefined ? pickedTaskCount + notPickedTaskCount : undefined;
};
